import { Encounter } from "@medplum/fhirtypes";

import { EncounterTypes } from "@/constants/encounter-type";
import { getCodeableConceptDisplay } from "@/utils/medplum";

/**
 * Get the amendment path for a given encounter based on its service type
 * @param encounter - The encounter to get the amendment path for
 * @returns The relative amendment path (e.g., "newborn-postpartum/amend")
 */
export const getAmendmentPath = (encounter?: Encounter): string => {
  if (!encounter) return "amend";

  const { serviceType } = encounter;
  const category = getCodeableConceptDisplay(serviceType) || "";

  switch (category) {
    case EncounterTypes.Postpartum:
      return "postpartum/amend";
    case EncounterTypes.NewbornPostpartum:
      return "newborn-postpartum/amend";
    case EncounterTypes.NewbornIPP:
      return "newborn-ipp/amend";
    case EncounterTypes.Gynecological:
      return "gynecological/amend";
    case EncounterTypes.LaborAndDelivery:
      return "labor/amend";
    case EncounterTypes.TransferOfCare:
      return "transfer-of-care/amend";
    default:
      return "amend";
  }
};
